// Propósito: vincular la conversación activa a la pestaña (sessionStorage), no al dispositivo.

const KEY_PREFIX = 'chatbot:activeConversation:';

export function tabConversationStorageKey(instanceId: string, botId: string): string {
  return `${KEY_PREFIX}${instanceId.slice(0, 64)}:${botId.slice(0, 64)}`;
}

export function getTabActiveConversationId(instanceId: string, botId: string): string | null {
  try {
    const raw = sessionStorage.getItem(tabConversationStorageKey(instanceId, botId));
    if (!raw || raw.length > 64) {
      return null;
    }
    return raw;
  } catch {
    return null;
  }
}

export function setTabActiveConversationId(
  instanceId: string,
  botId: string,
  conversationId: string,
): void {
  try {
    sessionStorage.setItem(
      tabConversationStorageKey(instanceId, botId),
      conversationId.slice(0, 64),
    );
  } catch {
    // sessionStorage puede estar bloqueado; el chat sigue con conversationId en memoria.
  }
}

export function clearTabActiveConversationId(instanceId: string, botId: string): void {
  try {
    sessionStorage.removeItem(tabConversationStorageKey(instanceId, botId));
  } catch {
    // ignore
  }
}

export function clearTabConversationsForInstance(instanceId: string): void {
  const boundedInstance = instanceId.slice(0, 64);
  try {
    const keysToRemove: string[] = [];
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (!key?.startsWith(KEY_PREFIX)) {
        continue;
      }
      const rest = key.slice(KEY_PREFIX.length);
      const instanceSegment = rest.split(':')[0] ?? '';
      if (instanceSegment === boundedInstance) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      sessionStorage.removeItem(key);
    }
  } catch {
    // ignore
  }
}
